/**
 * Shared behavior for sd-* marketing sections: a pause/play control for the
 * looping product demo (CSS-animated fallback or an actual <video>), and an
 * IntersectionObserver that stops any looping demo while it's off-screen.
 */
(function () {
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setPaused(root, paused) {
    root.classList.toggle('is-paused', paused);
    var video = root.querySelector('video[data-sd-demo-video]');
    if (video) {
      if (paused) video.pause();
      else video.play().catch(function () {});
    }
    var toggle = root.querySelector('[data-sd-demo-toggle]');
    if (toggle) {
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.setAttribute('aria-label', paused ? 'Play product demo' : 'Pause product demo');
    }
  }

  document.querySelectorAll('[data-sd-demo]').forEach(function (root) {
    if (prefersReducedMotion) setPaused(root, true);

    var toggle = root.querySelector('[data-sd-demo-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        setPaused(root, !root.classList.contains('is-paused'));
      });
    }

    if ('IntersectionObserver' in window) {
      var manuallyPaused = false;
      if (toggle) {
        toggle.addEventListener('click', function () {
          manuallyPaused = root.classList.contains('is-paused');
        });
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (manuallyPaused || prefersReducedMotion) return;
          setPaused(root, !entry.isIntersecting);
        });
      }, { threshold: 0.15 });
      observer.observe(root);
    }
  });

  // GA4 analytics for the hero's click-to-play video. GA4's built-in video
  // tracking only sees YouTube embeds, so this Shopify-hosted <video> reports
  // itself using GA4's standard video_* event names, plus a click event and a
  // video_watch_time event whose seconds_watched values sum to total watch time.
  function track(name, params) {
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
  }

  function videoParams(video, extra) {
    var params = {
      video_provider: 'shopify',
      video_title: 'Hero video',
      video_duration: Math.round(video.duration || 0),
      video_current_time: Math.round(video.currentTime || 0)
    };
    for (var key in extra) params[key] = extra[key];
    return params;
  }

  function trackHeroVideo(video) {
    if (video.dataset.sdTracked) return;
    video.dataset.sdTracked = 'true';

    var started = false;
    var milestones = [25, 50, 75];
    var lastTime = 0;
    var unreported = 0;
    var maxPercent = 0;

    function reportWatchTime() {
      if (unreported < 1) return;
      track('video_watch_time', videoParams(video, {
        seconds_watched: Math.round(unreported),
        video_percent: maxPercent
      }));
      unreported = 0;
    }

    video.addEventListener('play', function () {
      lastTime = video.currentTime;
      if (started) return;
      started = true;
      track('video_start', videoParams(video, { video_percent: 0 }));
    });

    video.addEventListener('timeupdate', function () {
      // Only count normal playback; a jump means the viewer seeked.
      var delta = video.currentTime - lastTime;
      if (delta > 0 && delta < 1.5) unreported += delta;
      lastTime = video.currentTime;

      if (!video.duration) return;
      var percent = Math.floor((video.currentTime / video.duration) * 100);
      if (percent > maxPercent) maxPercent = percent;
      while (milestones.length && percent >= milestones[0]) {
        track('video_progress', videoParams(video, { video_percent: milestones.shift() }));
      }
    });

    video.addEventListener('seeking', function () {
      lastTime = video.currentTime;
    });

    video.addEventListener('pause', reportWatchTime);

    video.addEventListener('ended', function () {
      maxPercent = 100;
      track('video_complete', videoParams(video, { video_percent: 100 }));
      reportWatchTime();
    });

    // Catches viewers who leave or switch tabs mid-video.
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') reportWatchTime();
    });
  }

  function playHeroVideo(stage, trigger) {
    if (!stage) return;
    var videoWrap = stage.querySelector('[data-sd-hero-video-wrap]');
    var crossfade = stage.querySelector('[data-sd-crossfade]');
    var video = videoWrap ? videoWrap.querySelector('video') : null;
    track('hero_video_click', { click_source: trigger });
    var playButton = stage.querySelector('[data-sd-play-video]');
    // Lives outside the screen, alongside it in the visual.
    var visual = stage.closest('.sd-hero-visual');
    var demoToggle = visual ? visual.querySelector('[data-sd-demo-toggle]') : null;
    if (videoWrap) videoWrap.hidden = false;
    if (crossfade) crossfade.style.display = 'none';
    if (playButton) playButton.style.display = 'none';
    // The toggle only drives the looping cover animation, which the video
    // has just replaced, so it would be a dead control from here on.
    if (demoToggle) demoToggle.style.display = 'none';
    if (video) {
      trackHeroVideo(video);
      video.muted = false;
      video.play().catch(function () {});
    }
  }

  document.querySelectorAll('[data-sd-play-video]').forEach(function (playButton) {
    playButton.addEventListener('click', function () {
      playHeroVideo(playButton.closest('.sd-device-screen'), 'play_button');
    });
  });

  document.querySelectorAll('[data-sd-play-video-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      var root = trigger.closest('[data-sd-demo]');
      var stage = root ? root.querySelector('.sd-device-screen') : null;
      if (!stage || !stage.querySelector('[data-sd-hero-video-wrap]')) return;
      event.preventDefault();
      playHeroVideo(stage, 'see_it_in_action_link');
    });
  });
})();
